;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.controllers')
    .controller('MainController', MainController)

  MainController.$inject = [
    'zlAuth', 'urls', 'version', '$uibModalStack',

    // Angular
    '$timeout', '$rootScope', '$uibModal',

    // Services
    'SidebarService', 'SessionService', 'DisplayService', 'NotificationService', 'PreferencesService', 'LoggerService', 'NtAppSwitcherService',

    // Managers
    'UserManager'

  ]

  function MainController (
    zlAuth, urls, version, $uibModalStack,

    // Angular
    $timeout, $rootScope, $uibModal,

    // Services
    SidebarService, SessionService, DisplayService, NotificationService, PreferencesService, LoggerService, NtAppSwitcherService,

    // Managers
    UserManager

  ) {
    const self = this

    /**
     *
     */
    self.$onInit = () => {
      _.extend(self, {
        display: DisplayService,
        sidebar: SidebarService,
        config: urls,
        version: version,
        goBack: DisplayService.goBack,
        changeTeam: zlAuth.changeTeam,
        allowSubcontracts: false,
        accessibleApps: [],
        userIsLoaded: false,
        isNotifSuperiorMax: isNotifSuperiorMax,
        newNotif: NotificationService.newNotif,
        getNotifications: NotificationService.getNotifications,
        getAllNotifications: NotificationService.getAllNotifications,
        markAsRead: markAsRead,
        markAllAsRead: NotificationService.markAllAsRead,
        countNotifications: NotificationService.countNotifications,
        appSwitcherService: NtAppSwitcherService,
        getCompany: SessionService.getCompany,
        disconnect: disconnect,
        clearCache: clearCache,
        isCompanyPrefsValid: isCompanyPrefsValid,
        isAdmin: isAdmin,
        displayChangeWorkspace: displayChangeWorkspace
      })
      init()
    }

    function init () {
      UserManager.getProfile().then(function (user) {
        self.currentUser = user
        self.currentCompany = _.find(user.companies, {_id: SessionService.getCompany()})
        self.appSwitcherService.getAccessibleApps().then((apps) => {
          self.accessibleApps = apps
          self.userIsLoaded = true
        })
        LoggerService.init({user: self.currentUser, company: self.currentCompany})
      })

      // Fix issue when user start clicking in modal, move mouse outside of modal
      $rootScope.$watch(() => document.querySelectorAll('.modal').length, val => { // everytime the number of modals changes
        for (let modal of document.querySelectorAll('.modal')) {
          if ($uibModalStack.getTop().value.backdrop !== 'static') { // Testing if the modal is supposed to be static
            modal.addEventListener('mousedown', e => {
              if (e.which === 1) {
                $uibModalStack.getTop().key.dismiss()
              }
            })
            modal.querySelector('.modal-content').addEventListener('mousedown', e => {
              e.stopPropagation()
            })
          }
        }
        if (val > 0) {
          $uibModalStack.getTop().value.backdrop = 'static'
        }
      })

      $rootScope.$on('subcontractorOptions', function (eevent, enabled) {
        self.allowSubcontracts = enabled
      })

      PreferencesService.getCompanyPrefs().then((companyPrefs) => {
        self.allowSubcontracts = _.get(companyPrefs, 'enabledFeatures.subcontracts')
      })
    }

    function isCompanyPrefsValid () {
      return PreferencesService.isCompanyPrefsValid()
    }

    function isAdmin () {
      return SessionService.isAdmin()
    }

    function disconnect () {
      zlAuth.disconnect({force: true})
    }

    function clearCache () {
      DisplayService.displayConfirm('Vider les caches', 'Êtes vous sûr de vouloir vider les caches ? <br>Cette action entrainera la perte de toutes vos préférences (dont le tableau de bord) .<br>Afin de confirmer la suppression du cache, merci d\'écrire "<strong class="text-danger">VIDER</strong>" dans le champs ci-dessous', 'VIDER').then(
        function () {
        })
    }

    /**
     * count if there is more than 80 notification unread to show 80+ on the badge
     */
    function isNotifSuperiorMax (numbernotif) {
      return numbernotif > 80
    }

    /**
     * Mark a notification as read
     * @param {Notification} notif - Notification to mark as read
     */
    function markAsRead (notif) {
      self.notifIsOpen = false
      notif.markAsRead().then(NotificationService.refreshNotifications)
    }

    function displayChangeWorkspace () {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: '/app/common/layouts/partials/modals/workspaces.html',
        resolve: {
          user: ['UserManager', function (UserManager) {
            return UserManager.getProfile()
          }],
          selectedCompany: ['SessionService', function (SessionService) {
            return SessionService.getCompany()
          }]
        },
        controller: 'ChangeWorkspaceModalController',
        controllerAs: 'workspaceModal'
      })
    }
  }
})(window.angular, window._)
